module.exports = __webpack_public_path__ + "img/nuovo_avviso_popup.6f86ee84.png";